import { Device } from "@gigauser/common/src/types/devices";

export const getVideoDevice = (width: number, height: number): Device => {
	return height > width ? "mobile" : "laptop";
};
